<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="tutorialId" :confirm="askConfirm"
                    :params="{tutorialId: tutorialId}" :title="$t('Modify')  + ' ' + $t('l') + ' ' +  $t('tutorial')"
                    route-back="TutorialShow"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('New')  + ' ' +  $t('tutorial')"
                    route-back="TutorialIndex"/>
      </div>

      <!-- Message de chargement -->
      <b-alert v-if="isLoading" show variant="info" class="mt-3">
        {{ $t('tutorial.uploadingAndCompressing') }}
      </b-alert>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.title.invalidFeedback"
                    :label="$t('tutorial.title')"
                    :state="form.title.state"
                    class="medium-label mb-4"
                    label-for="title-input">
                    <b-form-input
                      id="title-input"
                      v-model="form.title.value"
                      :state="form.title.state"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="removeInvalidFeedback('title'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.file.invalidFeedback"
                    :label="$t('tutorial.image.preview')"
                    :label-for="'file-input'"
                    :state="form.file.state"
                    class="medium-label mb-4">
                    <custom-form-file
                      :id="'file-input'"
                      v-model="form.file.value"
                      :browse-text="$t('Select')"
                      :placeholder="form.file.filename"
                      :state="form.file.state"
                      :required="false"
                      accept="image/*"
                      @change="removeInvalidFeedback('file')"
                    />
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.video.invalidFeedback"
                    :label="$t('tutorial.video')"
                    :label-for="'video-input'"
                    :state="form.video.state"
                    class="medium-label mb-4">
                    <b-form-file
                      :id="'video-input'"
                      v-model="form.video.value"
                      :browse-text="$t('Select')"
                      :invalid-feedback="form.video.invalidFeedback"
                      :placeholder="this.form.video.filename"
                      :required="!form.video.filename"
                      :state="form.video.state"
                      accept="video/*"
                      v-on:change="removeInvalidFeedback('video');">
                    </b-form-file>
                  </b-form-group>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button :disabled="isLoading" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: 'TutorialCreateEdit',
  components: {CustomFormFile, BackArrow},

  data() {
    return {
      tutorial: null,
      tutorialId: this.$route.params.tutorialId,
      askConfirm: false,
      isLoading: false,
      form: {
        title: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        file: {
          state: null,
          invalidFeedback: null,
          value: null,
          filename: null
        },
        video: {
          state: null,
          invalidFeedback: null,
          value: null,
          filename: null
        },
      },
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.tutorialId) await this.fetchTutorial()
    },

    async fetchTutorial() {
      await api.get(`/tutorial/${this.tutorialId}`).then(response => {
        this.tutorial = response.data
        this.form.title.value = this.tutorial.title
        this.form.file.filename = this.tutorial.preview ? this.tutorial.preview.filename : null
        this.form.video.filename = this.tutorial.video ? this.tutorial.video.filename : null
      })
    },

    onSubmit() {
      this.isLoading = true
      let data = new FormData()
      data.append('title', this.form.title.value)
      if (this.form.file && this.form.file.value) {
        data.append('file', this.form.file.value)
      }
      if (this.form.video && this.form.video.value) {
        data.append('video', this.form.video.value)
      }

      let url = '/tutorial'
      if (this.tutorial && this.tutorial.id) {
        url = '/tutorial/' + this.tutorial.id
      }

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(response => {
          this.isLoading = false
          this.$router.push({name: 'TutorialIndex'}, () => {
            this.$nextTick(() => {
              this.successToast(this.form.title.value)
            })
          })
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({name: 'TutorialIndex'})
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField].state = false
            this.form[invalidField].invalidFeedback = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback(field) {
      this.askConfirm = true
      this.form[field].state = null
      this.form[field].invalidFeedback = null
    },

    successToast(title) {
      this.$bvToast.toast(this.$i18n.t('Tutorial') + ' "' + title + '" ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/tutorial/TutorialCreateEdit.vue